export default __webpack_public_path__ + "static/media/exterior2.72a4e26d.webp";